import { PrismTextBody as SharedPrismTextBody } from "@lattice/shared-frontend/components";
import React from "react";
import { Streamdown } from "streamdown";
import "../chat-v8.css";

import { TableWidgetCard } from "./widgets/TableWidgetCard";

export type T_PrismTextBodyProps = {
  animated?: Parameters<typeof Streamdown>[0]["animated"];
  /** True while this part is still streaming (item.isLive). */
  isStreaming?: boolean;
  markdown: string;
};

/**
 * Web pieces for the shared PrismTextBody composer. The composer owns
 * segmentation, ordering, and branch selection; this file only says what a
 * markdown block, a table, and a stack look like on web.
 *
 * No renderMath slot: Streamdown renders display math natively, so the
 * composer's fallback hands math back as markdown with its delimiters.
 */
export function PrismTextBody({
  animated,
  isStreaming = false,
  markdown,
}: T_PrismTextBodyProps) {
  return (
    <>
      {SharedPrismTextBody({
        isStreaming,
        markdown,
        renderers: {
          renderMarkdown: ({ key, markdown: blockMarkdown }) => (
            <Streamdown animated={animated} isAnimating={isStreaming} key={key}>
              {blockMarkdown}
            </Streamdown>
          ),
          renderStack: (children) => (
            <div className="chat-v8-segment-stack">{children}</div>
          ),
          renderTable: ({ key, presentation }) => (
            <TableWidgetCard
              data={presentation.data}
              hiddenRowCount={presentation.hiddenRowCount}
              key={key}
            />
          ),
        },
      })}
    </>
  );
}
